<div class=" mt-3 p-md-3 ">

    <h2 class="text-center">
        In which state was your document issued ?
    </h2>

    <div class="row m-md-3 justify-content-around">
        @for (state of stateList; track $index) {
            <a [href]="'/' +state.code.toLowerCase()" class="btn btn-choose-state">
                {{state.code}}
            </a>
        }

    </div>
</div>

<!-- CMS content from /home slug -->
@if (sectionsRows.length > 0) {
    <div class="dynamic-page-wrapper py-3 py-md-4">
        <div class="container">
            @for (row of sectionsRows; track $index) {
                @if (row.length > 0 && row[0].section_type !== 'title') {
                    <div class="row g-4 g-lg-5 justify-content-center align-items-center mb-4 mb-md-5">
                        @for (item of row; track $index) {
                            @if (item.section_type !== 'sidebar') {
                                <div [innerHTML]="item.content" [class]="'col-md-'+(12/row.length)" class="dynamic-content-col"></div>
                            }
                        }
                    </div>
                } @else if (row.length > 0 && row[0].section_type === 'title') {
                    <div class="text-center mb-4">
                        <h2 class="fw-bold">{{ row[0].content }}</h2>
                    </div>
                }
            }
        </div>
    </div>
}
